module.exports = __webpack_public_path__ + "img/floatExplain.3001a3e9.svg";